var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-navbar-fixed-top",class:'page--' + _vm.$route.name,attrs:{"id":"app"}},[_c('navbar',{staticClass:"is-fixed-top"}),_c('transition',{attrs:{"name":"raijin-fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }